import { render, staticRenderFns } from "./CommunicationAddressActivity.vue?vue&type=template&id=7a90c45b&scoped=true&"
import script from "./CommunicationAddressActivity.vue?vue&type=script&lang=js&"
export * from "./CommunicationAddressActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90c45b",
  null
  
)

export default component.exports